import loading from './loading'
export  default  loading



// WEBPACK FOOTER //
// ./components/Cc-Loading/index.js